var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bige cont cgu" }, [
    _c(
      "div",
      { staticClass: "cont cgu", staticStyle: { "padding-top": "150px" } },
      [
        _c("h1", [
          _vm._v("Conditions Générales d’Utilisation de l’Application IDTROC")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "tagline" }, [
          _vm._v("Date de dernière mise à jour le 06/10/2021")
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _vm._m(4),
        _vm._v(" "),
        _vm._m(5),
        _vm._v(" "),
        _vm._m(6),
        _vm._v(" "),
        _vm._m(7),
        _vm._v(" "),
        _c("article", [
          _c("h2", [_vm._v("9) Données personnelles")]),
          _vm._v(" "),
          _c(
            "p",
            [
              _vm._v(
                "\n        OKAIDI SAS, responsables du traitement, collectent des données\n        personnelles obligatoires signalées par un astérisque. Ces données\n        collectées sont nécessaires pour l’utilisation du service IDTROC.\n        D’autre part, ces données peuvent être nécessaires pour adresser, des\n        offres, des actualités ou des publicités personnalisées ou non,\n        uniquement en cas d’acceptation de celles-ci. Elles pourront également\n        être utilisées pour la réalisation d’analyses statistiques.\n        "
              ),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "Les sociétés OKAIDI SAS assurent prendre toutes les mesures\n        nécessaires, conformément aux dispositions légales applicables, pour\n        assurer la protection, la confidentialité et la sécurité de vos\n        données personnelles.\n        "
              ),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "Conformément à la loi Informatique et Libertés du 6 janvier 1978\n        et au Règlement Général sur la Protection des Données (RGPD) du 14\n        Avril 2016, vous bénéficiez d’un droit d’accès, d’édiction des\n        directives anticipées, de rectification, d’opposition, d’effacement,\n        de portabilité ou de limitation aux traitements de données vous\n        concernant. Vous pouvez exercer vos droits en écrivant à IDKIDS,\n        Service Client OKAÏDI, 162 boulevard de Fourmies, 59100 Roubaix ou par\n        email à\n        "
              ),
              _c(
                "a",
                {
                  staticClass: "hyperlink",
                  attrs: {
                    href: "mailto:customerservice@idkids.com",
                    title: "écrire au service client idkids"
                  }
                },
                [_vm._v("\n          customerservice@idkids.com\n        ")]
              ),
              _vm._v(
                "\n        pour OKAIDI. Pour d’avantage d’informations sur vos données\n        personnelles, veuillez consulter la « politique de données\n        personnelles » :\n        "
              ),
              _c(
                "router-link",
                {
                  attrs: {
                    to: "/politique-confidentialite",
                    target: "_self",
                    name:
                      "politique de confidentialité de l'application idtroc",
                    rel: "tag"
                  }
                },
                [_vm._v("\n          cliquez ici\n        ")]
              ),
              _vm._v("\n        .\n      ")
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm._m(8),
        _vm._v(" "),
        _vm._m(9),
        _vm._v(" "),
        _vm._m(10),
        _vm._v(" "),
        _vm._m(11),
        _vm._v(" "),
        _vm._m(12),
        _vm._v(" "),
        _vm._m(13)
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [_vm._v("1) Objet")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Les présentes Conditions Générales d’Utilisation (ci-après dénommées\n        « CGU »), ont pour objet de déterminer les règles d’utilisation de\n        l’application mobile « IDTROC » (ci-après dénommée l’Application »)\n        éditée par la société OKAIDI SAS, au capital de 6 483 008,00 €, 162\n        Boulevard de Fourmies, 59100 Roubaix, immatriculée au RCS de Lille\n        Métropole sous le n°398 110 445 Ci-après «IDKIDS»\n        "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v("Et\n        "),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "Toute personne physique téléchargeant et/ou utilisant\n        l’Application IDTROC pour notamment y enregistrer un dépôt d’article.\n        "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v("Ci-après « l'Utilisateur »\n        "),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "Les présentes Conditions visent à définir les modalités\n        d’utilisation de l’Application et les conditions dans lesquelles\n        IDKIDS met en relation l’Utilisateur de l’Application et le magasin de\n        dépôt pour bénéficier du service de dépôt IDTROC. Elles précisent\n        toutes les étapes nécessaires entre les parties contractantes.\n        "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "En installant l’Application sur votre terminal et/ou en accédant\n        à l’Application, en tant que visiteur et/ou Utilisateur, vous acceptez\n        sans condition ni réserve l’intégralité des CGU définies ci-après. Si\n        vous ne souhaitez pas accepter les présentes CGU, nous vous demandons\n        de ne pas accéder à l’Application. "
        ),
        _c("br"),
        _vm._v(
          "Toute visite et/ou\n        utilisation de l’Application doit se faire dans le respect des\n        présentes CGU. "
        ),
        _c("br"),
        _vm._v(
          "Les CGU pouvant faire l’objet de modifications,\n        les conditions applicables sont celles en vigueur sur l’Application\n        IDTROC à la date de validation du dépôt des Produits par l’utilisateur\n        en magasin.\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [_vm._v("2) Objet de l’application")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        La présente Application propose un service de dépôt en vue d’une vente\n        évènementielle, permettant ainsi aux Utilisateurs de préparer le dépôt\n        de Produits d’occasion de nos marques textile, livres, jouets ou\n        puériculture à vendre en magasin durant les périodes prévues sur un\n        espace délimité dans nos magasins participants (IDKIDS, Okaïdi,\n        Oxybul, Catimini) via un contrat de dépôt-vente.\n        "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "Par ce biais, IDKIDS ne sera pas partie à la vente qui\n        interviendrait entre un déposant et l’acheteur. IDKIDS, par\n        l’Application, vient faciliter la transaction, et par conséquent, ne\n        procède pas à l’achat pour revente des Produits des déposants.\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [_vm._v("3) Accès à l’application et ses fonctionnalités")]),
      _vm._v(" "),
      _c("h3", [_vm._v("3.1. Matériel")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Pour accéder et utiliser l’Application, vous devez posséder un\n        téléphone compatible ou un terminal mobile et un accès au réseau\n        internet.\n        "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "L’application est téléchargeable gratuitement depuis les\n        terminaux mobile disposant du système d’exploitation IOS (Apple\n        Store), ou Android (Google Play Store).\n        "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "La version du logiciel de l’Application peut être mise à jour de\n        temps à autre pour ajouter de nouvelles fonctions et de nouveaux\n        services. "
        ),
        _c("br"),
        _vm._v(
          "L’Utilisation de l’Application et de ses services est\n        limitée à la France.\n      "
        )
      ]),
      _vm._v(" "),
      _c("h3", [
        _vm._v("3.2. Inscription et création d’un compte sur l’Application")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        L’utilisation de l’Application impose à l’Utilisateur de s’inscrire et\n        de créer un compte, dont l’accès sera sécurisé par la vérification de\n        son identité.\n        "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "La création d’un compte nécessite que l’Utilisateur y indique\n        obligatoirement son numéro de téléphone portable. L’utilisateur est\n        tenu de fournir des informations exactes. "
        ),
        _c("br"),
        _vm._v(
          "L’Inscription devra\n        être confirmée par l’Utilisateur en saisissant le code de validation\n        reçu par SMS au numéro de téléphone portable précédemment communiqué\n        par l’Utilisateur. "
        ),
        _c("br"),
        _vm._v(
          "L’Utilisateur s’engage à ne créer qu’un seul\n        compte.\n        "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "Afin de valider son dépôt, l’utilisateur devra également\n        renseigner son adresse email, ainsi que ses noms, prénoms, adresse\n        postale, et sa pièce d’identité (n° de pièce, date de délivrance,\n        autorité de délivrance et date d’expiration). Cette liste n’est pas\n        limitative.\n        "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "L’Utilisateur est entièrement responsable de la protection de\n        son compte. Son identifiant constitue la garantie de la\n        confidentialité des informations contenues dans son compte et\n        l’Utilisateur s’interdit donc de le transmettre ou de le communiquer à\n        un tiers. A défaut, l’Editeur de l’application ne pourra pas être tenu\n        pour responsable des accès non autorisés au compte d’un Utilisateur.\n        "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "L’Editeur se réserve le droit exclusif de supprimer le compte de\n        tout Utilisateur qui aurait contrevenu aux présentes CGU (notamment\n        mais sans que cet exemple n’ait un quelconque caractère exhaustif,\n        lorsque l’Utilisateur aura fourni sciemment des informations erronées\n        dans l’application). Ladite suppression ne sera pas susceptible de\n        constituer un dommage pour le membre exclu qui ne pourra prétendre à\n        aucune indemnité de ce fait. L’Editeur conserve la possibilité\n        d’entreprendre des poursuites d’ordre judiciaire à l’encontre de\n        l’Utilisateur, lorsque les faits l’auront justifiée.\n      "
        )
      ]),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n        3.3. Inscription ou renouvellement de l’adhésion au programme de\n        fidélité OKAÏDI-OXYBUL, IDKÏDS.\n      "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        L’utilisation de l’Application IDTROC impose également à l’Utilisateur\n        d’être adhérent au programme de fidélité. L’Utilisateur a ainsi la\n        possibilité de : s’inscrire ou de renouveler, en cas d’expiration, son\n        adhésion au programme de fidélité OKAÏDI-OXYBUL- IDKÏDS. La\n        vérification s’opérera en magasin lors du dépôt des articles. En cas\n        d’adhésion ou de renouvellement, les formalités s’effectueront lors du\n        dépôt du ou des Produits en magasin.\n      "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("3.4. Conditions diverses")]),
      _vm._v(" "),
      _c("p", [_vm._v("L’Utilisateur déclare :")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "\n          être une personne physique majeure et avoir la capacité de conclure\n          le présent contrat,\n        "
          )
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("ne pas être commerçant et vendeur professionnel")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n          que les informations et données personnelles communiquées sur\n          l’Application sont exactes\n        "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n          accepter les présentes Conditions Générales d’Utilisation de\n          l’Application et les Conditions du programme de fidélité souscrit\n        "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [_vm._v("4) Géolocalisation")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Afin de visualiser les magasins participant à proximité de\n        l’Utilisateur, ce dernier peut, à son choix, activer le service de\n        géolocalisation.\n        "
        ),
        _c("br"),
        _vm._v(
          "L'utilisation de la fonctionnalité de géolocalisation de\n        l'Application nécessitera le consentement préalable express de\n        l'utilisateur à être géolocalisé. Pour cela, l'Utilisateur devra\n        activer, s'il le souhaite, la fonction de géolocalisation directement\n        dans les réglages de son terminal mobile et accepter que l'Application\n        puisse y avoir recours. Cette fonctionnalité peut, à tout moment, et\n        sans frais, être désactivée ou activée via la rubrique « réglages » de\n        son terminal mobile. "
        ),
        _c("br"),
        _vm._v(
          "Grâce à l'acceptation de la fonction de\n        géolocalisation par GPS du téléphone mobile et de l'Application,\n        l'utilisateur peut être informé des magasins se trouvant au plus près\n        pour pouvoir effectuer le dépôt.\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [_vm._v("5) Conditions financières")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        L’Application est proposée gratuitement aux Utilisateurs hors coûts\n        d’abonnement auprès de l’opérateur de téléphonie mobile, hors coûts de\n        connexion et d’accès au réseau Internet, hors surcoût éventuel facturé\n        pour le chargement des données, et hors coût du programme de fidélité.\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [_vm._v("6) Modalités du dépôt")]),
      _vm._v(" "),
      _c("h3", [_vm._v("6.1. Sélection du magasin :")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        l’Utilisateur sélectionne le magasin à proximité afin de pouvoir\n        visualiser les ventes événementielles auxquelles il peut participer.\n      "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("6.2. Articles éligibles :")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        En fonction de la marque organisatrice (OKAIDI, OBAIBI, , OXYBUL,\n        ÏDKIDS) et de la thématique de l’IDTROC, les produits éligibles au\n        dépôt sont précisément définis (Vêtements de marques OKAIDI,\n        OBAIBI, CATIMINI, Z, LILI GAUFRETTE, ABSORBA, JEAN BOURGET, BECKARO,\n        3 POMMES, CHIPIE et jouets ou livres chez OXYBUL et IDKIDS).\n        "
        ),
        _c("br"),
        _vm._v(
          "Notamment, concernant les produits OKAIDI : t-shirt manches\n        longues – pull, gilet, sweat – chemise, blouse – legging – pantalon –\n        robe – jupe – salopette – pyjama – manteau ½ saison – manteau hiver,\n        etc. "
        ),
        _c("br"),
        _vm._v(
          "Tous les autres Produits, tels que notamment les\n        chaussures, accessoires et sous-vêtements (hors body), ne sont pas\n        admis au dépôt.\n      "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("6.3. Validation de participation :")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        l’Utilisateur valide sa participation à l’opération, et renseigne à ce\n        titre les informations nécessaires à l’établissement du contrat de\n        dépôt : nom, prénom, adresse email, adresse postale, n° de pièce\n        d’identité, date de délivrance, autorité de délivrance et date\n        d’expiration.\n        "
        ),
        _c("br"),
        _vm._v(
          "Le déposant est alors lié par un contrat de dépôt, le magasin\n        devient alors dépositaire des articles, ce qui lui permet de les\n        proposer au cours de la vente événementielle concernée.\n      "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("6.4. Préparation du dépôt :")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        le déposant enregistre ses articles à déposer. Pour ce faire, il joint\n        une photo de l’article, renseigne la marque (OKAIDI, OBAIBI, OXYBUL,\n        CATIMINI, Z, LILI GAUFRETTE, ABSORBA, JEAN BOURGET, BECKARO, 3 POMMES,\n        CHIPIE), indique si l’article est à destination des filles ou garçons,\n        choisi la catégorie du Produit.\n        "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "L’Utilisateur doit joindre au moins une photo de l’article, de\n        qualité suffisante. La photo doit avoir été prise par l’Utilisateur,\n        ne peut provenir de photographies issues d’Internet, et doit\n        correspondre à l’article qui sera effectivement déposé par\n        l’Utilisateur. "
        ),
        _c("br"),
        _vm._v(
          "Lesdites photographies ne sont pas contraires à\n        l’ordre public et aux bonnes mœurs.\n      "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("6.5 Fixation des prix :")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Les prix sont présentés en euros toutes taxes comprises. La marque\n        organisatrice fixe le prix des Produits en fonction de la catégorie\n        auquel il appartient et de sa typologie. La marque se réserve le droit\n        de modifier ses prix à tout moment. Toutefois, les Produits seront\n        facturés sur la base des tarifs en vigueur, conformément à ceux\n        affichés au jour du dépôt. Le déposant accepte que le prix des\n        articles non vendus soit remisé de 30% aux dates indiquées sur le\n        contrat.\n      "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("6.6. Finalisation :")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        L’Utilisateur récupère le numéro de contrat affilié à son dépôt, et\n        reçoit un email avec les étiquettes prix à imprimer chez soi, ou en\n        magasin, à apposer sur ses articles.\n      "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("6.7. Dépôt :")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Il dépose dans le magasin participant ses articles étiquetés aux dates\n        indiquées sur le contrat.\n      "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("6.8. Validation du dépôt :")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Le magasin est libre d’accepter ou de refuser le dépôt d’articles en\n        cas de surstock ou d’articles ne répondant pas à ses exigences de\n        qualité et de sécurité.\n      "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        En effet, lors du dépôt d’un Produit par l’Utilisateur en magasin, le\n        magasin procédera à quelques vérifications, parmi lesquelles:\n      "
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v("Vérification du numéro de contrat présent sur l’Application.")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n          Vérification de l’adhésion au programme de fidélité: l’adhésion doit\n          être valide et non expirée au moment du dépôt du Produit par le\n          Vendeur. Etant une obligation pour utiliser le service de dépôt\n          IDTROC, le refus d’adhésion ou le refus de renouvellement au\n          programme de fidélité entraînera l’annulation du dépôt.\n        "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n          Vérification de la qualité du Produit déposé: la vérification\n          portera au minimum sur les éléments suivants:\n        "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n          Vérification de la marque du Produit déposé, notamment via\n          l’étiquette de la marque\n        "
          )
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("Vérification de la taille du Produit déposé")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n          Vérification des défauts apparents, tels que Produit troué, usé,\n          taché, décoloré, bouloché, accessoires manquants ou cassés, etc.\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("\n        Pour les jouets:\n      ")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "\n          Jeux et jouets acceptés : en parfait état visuel (article et emballage/boîte),\n          de fonctionnement (piles neuves…) et complets.\n        "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n          Catégories acceptées : jouets d’éveil, jeux de société, de construction,\n          d’imitation, jeux éducatifs et de plein air, déguisements.\n        "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n          Marques acceptées : marques Oxybul et marques nationales.\n        "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n          Un jouet composé de plusieurs pièces doit être soit :\n          dans l’emballage d’origine (obligatoire pour les jeux de société et puzzle)\n          dans un emballage transparent et hermétique (pochette, box, bocal…)\n          assemblé proprement avec un scotch transparent ou un film plastique sans risque\n          de détérioration au retrait.\n          - Les jouets textiles doivent être lavés, propres, sans tâche ni déchirure.\n        "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n          Les Lego, Duplo, Playmobil, Kapla… peuvent être incomplets s’ils sont\n          dans un emballage transparent et hermétique.\n        "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n          Ne sont pas acceptés : jouets à pile sans pile, puzzles > 50 pièces, poupées,\n          peluches, articles roulants, trampolines, portiques, aire de jeux, maisons et tentes,\n          articles gonflables, produits électriques et jeux multimédia,\n          articles de loisirs créatifs utilisés.\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("\n        Pour les livres:\n      ")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "\n          Livres acceptés : livres pour enfant ou guides parentaux en parfait état.\n        "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n          Ne sont pas acceptés : les livres sales, jaunis, déchirés, raturés,\n          avec la mention « ne pas vendre » ou gratuits, de collections trop anciennes,\n          livres-cd, livres-puzzle et livres coloriages.\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("Pour le textile :")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "\n          Textile accepté : articles des marques OKAÏDI-OBAÏBI uniquement, en parfait état,\n          propres, zip fonctionnel, sans tâche, ni bouloche, ni trou, ni coloris passé/délavé,\n          ni bouton ou pression manquants, repassés. Les ensembles sont à vendre séparément.\n          - Ne sont pas acceptés : sous-vêtements (hors body), chaussures et accessoires, et les articles en mauvais état.\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("6.9. Vente :")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        La vente est prise en charge par le magasin et se déroule aux dates\n        indiquées sur le contrat.\n      "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Les articles IDTROC achetés, sur cette période, ne sont ni remboursables ni échangeables.\n      "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n        Moyens de paiement acceptés :"),
        _c("br"),
        _vm._v(
          "\n        Espèces, CB, chèques KADEO, tir groupé, CADHOC, cartes cadeaux OKAIDI-OBAIBI, OXYBUL et IDKIDS.\n      "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Les cartes cadeaux IDTROC (disponibles sur l’application IDTROC ou envoyées par email)\n        ne sont pas utilisables comme moyen de paiement pour acheter du troc.\n      "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("6.10. Don des invendus :")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Le Déposant peut retirer en rayon ses invendus aux dates indiquées sur\n        le contrat, sur présentation du code-barres du contrat et d’une pièce\n        d’identité. Passé ce délai, tous les invendus restants sont donnés\n        d’office soit au Love Bag pour les IDTROC OKAÏDI-OBAÏBI, ou à\n        l’association parrainée par le magasin pour les IDTROC OXYBUL-ÏDKIDS\n        dédiés aux livres, jouets ou puériculture.\n      "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("6.11. Carte cadeau :")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        La carte cadeau est matérialisée par un code-barres présent sur\n        l’Application. Elle sera créditée du montant des ventes à partir de la\n        date indiquée sur le contrat. Le montant est précisé sur la page du\n        code-barre. Non remboursable, elle est utilisable pendant deux mois à\n        compter de sa date d’envoi, en plusieurs fois, chez OXYBUL, OKAÏDI,\n        OBAÏBI, ÏDKIDS, CATIMINI en magasin et sur internet (Carte bancaire = 19 1er\n        chiffres du n° de carte cadeau, code sécurité = 4 derniers chiffres)\n        dans le pays où a eu lieu l’IDTROC. Le montant maximum d’une E-carte\n        cadeau est de 150 euros. A ce titre, si le montant total des Produits\n        vendus par le Vendeur est supérieur à cette somme, plusieurs E-cartes\n        cadeaux de valeurs différentes seront mises à disposition sur\n        l’Application.\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [_vm._v("7) Obligations des Parties")]),
      _vm._v(" "),
      _c("h3", [_vm._v("7.1. Articles déposés :")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Le Déposant s’engage à confier des articles en parfait état, propres,\n        complets et sans aucun risque pour l’utilisateur sachant qu’il sera\n        responsable des dommages ou pertes dont pourrait être victime\n        l’acheteur ou tout autre personne du fait des articles vendus par lui\n        lors de l’IDTROC. Le Déposant s’engage notamment à ne pas déposer\n        d’articles ayant fait l’objet d’un rappel produit. Il garantit\n        également, dans le cadre de son dépôt, ne pas enfreindre les droits de\n        propriété des tiers.\n      "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("7.2. L’Utilisateur s’engage")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        à n’utiliser l’Application qu’à des fins légales. Il s’engage à ne pas\n        faire d’utilisation qui contreviendrait à une loi ou réglementation\n        locale, nationale ou internationale applicable. Il s’engage également\n        à ne pas accéder sans autorisation à endommager ou perturber\n        l’Application ou un matériel utilisé dans la fourniture de notre\n        Service, et à renseigner, lors de la création de son compte sur\n        l’application, des informations exactes et sincères.\n      "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("En tant que dépositaire, IDKIDS s’engage à :")]),
      _vm._v(" "),
      _c("h4", [_vm._v("7.3. Ecoulement :")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        faire ses meilleurs efforts pour faciliter la vente des articles\n        confiés mais ne garantit pas la vente de ceux-ci.\n      "
        )
      ]),
      _vm._v(" "),
      _c("h4", [_vm._v("7.4. Prix de vente :")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Respecter le prix de vente des articles indiqués sur le contrat et\n        appliquer une remise de 30% aux dates prévues (cf article 6.5).\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [_vm._v("8) Responsabilité")]),
      _vm._v(" "),
      _c("h3", [_vm._v("8.1. Responsabilité de OKAÏDI SAS/JACADI SAS")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        OKAÏDI SAS ne sera pas responsable de la non-exécution totale ou\n        partielle de ses obligations au titre du présent contrat, si cette\n        non-exécution résulte, soit de l’Utilisateur, soit d’un cas de force\n        majeure (article 1218 du Code civil).\n        "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "La responsabilité d’OKAÏDI SAS ne saurait être engagée pour tous\n        les inconvénients ou dommages inhérents à l’utilisation du réseau\n        internet, notamment une rupture du service, une intrusion extérieure\n        ou la présence de virus informatiques, la perte, le retard ou l’erreur\n        de transmission de données qui sont indépendants de sa volonté, ou de\n        fait qualifié de force majeure, conformément à la jurisprudence.\n        "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "L’accès et l’utilisation de l'Application se font aux risques et\n        périls de l'Utilisateur. "
        ),
        _c("br"),
        _vm._v(
          "L’Application et le logiciel sont\n        fournis « tel quel » et « comme disponible » sans garantie quelle\n        qu’elle soit. "
        ),
        _c("br"),
        _vm._v(
          "Il appartient à tout Utilisateur de prendre toutes\n        les mesures appropriées de façon à protéger ses propres données et/ ou\n        logiciels stockés sur ses équipements informatique et téléphonique\n        contre toute atteinte. "
        ),
        _c("br"),
        _vm._v(
          "Par ailleurs, OKAIDI SAS décline toute\n        responsabilité en cas de mauvaise utilisation du terminal et/ou\n        d'incident lié à l'utilisation du terminal lors de l’utilisation de\n        l’Application. OKAIDI SAS ne saurait en aucun cas être tenue\n        responsable de tout dommage, de quelque nature que ce soit, causé aux\n        Utilisateurs, à leurs terminaux, à leurs équipements informatiques et\n        téléphoniques et aux données qui y sont stockées ni des conséquences\n        pouvant en découler.\n      "
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("8.2. Responsabilité de l’Utilisateur")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        En téléchargeant et/ou en utilisant l’Application et en acceptant les\n        Conditions Générales d’Utilisation, l’Utilisateur reconnait notamment\n        que :\n      "
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "\n          Il est responsable des dommages directs ou indirects découlant du\n          non-respect des CGU ;\n        "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Il est responsable des dépôts effectués sur l’Application ;")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [_vm._v("10) Propriété intellectuelle")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        L'intégralité de l’Application est protégée par les législations\n        françaises et internationales relatives à la propriété intellectuelle.\n        Toutes les marques, textes, commentaires, ouvrages, illustrations et\n        images, qu'ils soient visuels ou sonores, reproduits sur l’Application\n        sont protégés au titre du droit d'auteur, droit des marques, droit des\n        brevets, droit à l'image pour le monde entier. A ce titre, toute\n        reproduction ou représentation totale ou partielle de l’Application ou\n        de tout ou partie des éléments se trouvant sur l’Application est\n        strictement interdite.\n        "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "L’Utilisateur déclare quant à lui n’utiliser que des photos pour\n        lesquels il détient les droits de Propriété Intellectuelle.\n        "
        ),
        _c("br"),
        _vm._v(
          "IDKIDS concède à l’Utilisateur un droit personnel d’utilisation\n        de l’Application, du Contenu et des Services, non exclusif, révocable,\n        non cessible, non transférable, mondial et gratuit uniquement pour ses\n        besoins propres dans le cadre de l’utilisation de l’Application et des\n        Services, à l’exclusion de toute autre finalité. "
        ),
        _c("br"),
        _vm._v(
          "Il est\n        strictement interdit à l’Utilisateur d’accéder et/ou d’utiliser les\n        codes source de l’Application et/ou des composants logiciels de\n        l’Application. "
        ),
        _c("br"),
        _vm._v(
          "L’Utilisateur n’acquiert aucun droit de propriété\n        intellectuelle sur l’Application, le Contenu et/ou les Services ni\n        aucun autre droit que ceux conférés par les présentes.\n        "
        ),
        _c("br"),
        _vm._v(
          "L’Utilisateur est responsable des photographies qui accompagnent\n        son dépôt et déclare détenir à ce titre tous droits sur celles-ci.\n        L’Utilisateur concède à IDKIDS, une licence non exclusive pour le\n        monde, à titre gratuit, pour le temps nécessaire à la vente des\n        Produits. Cette licence comprend le droit, sur tous supports,\n        d’utiliser, de copier, de reproduire, d’afficher et d’adapter le\n        contenu des photographies fournies.\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [_vm._v("11) Informations générales aux Utilisateurs")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        En tant qu’Application de dépôt en vue de la mise en vente des\n        articles, IDKIDS informe de façon loyale, claire et transparente ses\n        Utilisateurs de leurs obligations suivantes :\n      "
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v("\n          Obligation fiscale :\n          "),
          _c(
            "a",
            {
              staticClass: "hyperlink",
              attrs: { href: "https://www.impots.gouv.fr/portail/node/10841" }
            },
            [
              _vm._v(
                "\n            https://www.impots.gouv.fr/portail/node/10841\n          "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("\n          • Obligation sociale :\n          "),
          _c(
            "a",
            {
              staticClass: "hyperlink",
              attrs: {
                href:
                  "https://www.urssaf.fr/portail/home/espaces-dedies/activites-relevant-de-leconomie.html"
              }
            },
            [
              _vm._v(
                "\n            https://www.urssaf.fr/portail/home/espaces-dedies/activites-relevant-de-leconomie.html\n          "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Conformément à l’article D7342-5 du Code du travail, le travailleur\n        indépendant remplissant l’ensemble des conditions définies à l’article\n        L.7342-1 du même Code peut adresser une demande de remboursement des\n        cotisations, contributions et frais mentionnés aux articles D.7342-1 à\n        D.7342-3, accompagnée de l’ensemble des pièces justificatives, à\n        l’adresse suivante :\n        "
        ),
        _c(
          "a",
          {
            staticClass: "hyperlink",
            attrs: {
              href: "mailto:customerservice@idkids.com",
              title: "écrire au service client idkids"
            }
          },
          [_vm._v("\n          customerservice@idkids.com\n        ")]
        ),
        _vm._v("\n        pour OKAIDI.\n      ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [_vm._v("12) Intégralité")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Dans l’hypothèse où l’une des clauses du présent contrat serait nulle\n        et non avenue par un changement de législation, de réglementation ou\n        par une décision de justice, cela ne saurait affecter la validité et\n        le respect des présentes Conditions Générales d’Utilisation.\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [_vm._v("13) Durée")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Les présentes Conditions s’appliquent pendant toute la durée de prise\n        en charge du dépôt sur l’Application.\n        "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "IDKIDS peut mettre fin à l’utilisation de l’Application à tout\n        moment en vous donnant un préavis de résiliation. "
        ),
        _c("br"),
        _vm._v(
          "Au moment de\n        toute résiliation, les droits et licences qui ont été accordés seront\n        résiliés, et l’utilisateur cessera toute utilisation de l’Application.\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [_vm._v("14) Litiges et droit applicable")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Les présentes Conditions Générales d’Utilisation sont soumises à la\n        législation française. Les parties tenteront dans un premier temps de\n        régler le litige à l’amiable.\n      "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Conformément aux dispositions du Code de la Consommation,\n        l’Utilisateur a le droit de recourir gratuitement au service de\n        médiation proposé par OKAIDI SAS, dès lors qu'un tel litige n'a pas pu\n        être réglé dans le cadre d'une réclamation préalable directement\n        introduite auprès du service Client d’OKAIDI SAS.\n      "
        )
      ]),
      _vm._v(" "),
      _c("address", [
        _c("p", [
          _vm._v(
            '\n          Le médiateur « droit de la consommation » ainsi proposé est la "CM2C".\n          Ce dispositif de médiation peut être joint par :\n        '
          )
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _vm._v("\n            Voie électronique: "),
            _c(
              "a",
              {
                staticClass: "hyperlink",
                attrs: {
                  href: "mailto:cm2c@cm2c.net",
                  title: "écrire au dispositif de médiation"
                }
              },
              [_vm._v("\n              cm2c@cm2c.net\n            ")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n            Ou par voie postale : CM2C, 14 rue Saint Jean 75017 Paris\n          "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        A défaut de règlement amiable, les différends qui viendraient à\n        se produire à propos de la validité, l’interprétation, l’exécution ou\n        la cessation du présent contrat seront soumis à la compétence des\n        tribunaux français, nonobstant pluralité de défendeurs et/ou appel en\n        garantie, même pour les procédures d’urgence ou les procédures\n        conservatoires en référé ou par requête. Le tribunal compétent en cas\n        de litige sera celui du lieu du domicile du défendeur.\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [_vm._v("15) Services clients")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Le Service client OKAIDI est joignable par téléphone au\n        "
        ),
        _c("a", { attrs: { href: "tel:+33969392390" } }, [
          _vm._v("\n          09 69 39 23 90\n        ")
        ]),
        _vm._v(
          "\n        (appel non surtaxé) Du lundi au vendredi de 9h à 19h et le SAMEDI de\n        9h30 à 18h ou\n        "
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.okaidi.fr/contactus",
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [
            _vm._v(
              "\n          en complétant le formulaire de contact ici\n        "
            )
          ]
        ),
        _vm._v(".\n      ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Pour les questions relatives à l’IDTROC chez CATIMINI, le Service\n        client CATIMINI est joignable par téléphone au\n        "
        ),
        _c("a", { attrs: { href: "tel:+33352526214" } }, [
          _vm._v("\n          03 52 52 62 14\n        ")
        ]),
        _vm._v("\n        du lundi au vendredi de 9h à 18h ou\n        "),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://support.catimini.com/hc/fr/articles/360034583694-Je-souhaite-contacter-le-service-client-Catimini",
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [
            _vm._v(
              "\n          en complétant le formulaire de contact ici.\n        "
            )
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1cc81bde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cc81bde","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CGU.vue
// module id = null
// module chunks = 